/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable camelcase */
/* CMI-S UI */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  Checkbox,
  Chip,
  Col,
  Container, IconButton, Row, Spinner, Typography,
} from '@airbus/components-react';
import { AddCircleOutline } from '@airbus/icons/react';
import _ from 'lodash';
import posthog from 'posthog-js';
import React, {
  useCallback, useEffect, useRef, useState,
} from 'react';
import { setReasonTab } from '../../models/appConfigModel/appConfigSlice';
import {
  setCurrentPopupDetails,
  setFinBottomDrawerStatus,
  setFleetDetailSelectedFin,
  toggleFilterModel,
  toggleReasonDetail,
  uncheckClfState,
  updateCheckerDetailsColumnFilterPayload,
  updateCheckerDetailsColumnFilterState,
  updateCheckerDetailsDataPagination,
  updateSelectAllBottomDrawerStatus,
} from '../../models/checkerDetailsModel/checkerDetailsSlice';
import { loadCheckerDetails, loadCheckerDetailsClfData, loadCheckerDetailsFilterData } from '../../models/checkerDetailsModel/checkerDetailsThunk';
import { useAppDispatch, useAppSelector } from '../../store/hooksTypes';
import {
  getFromLocalStore, getPermissionForModule,
} from '../../utils/commonMethods/generalMethods';
import { createPayloadObjForChecker, extractFilterSelected } from '../../utils/commonMethods/generalMethodsExtended';
import { handleCheckerDetailsPageChange } from '../../utils/commonUtil';
import {
  CHECKER, DATA_WARNING_TEXT, DEFAULT_OFFSET, INTERNAL_ABUS, NO_TABLE_RECORDS_FOUND, READ_ONLY_ARR, REASON_DETAIL_INITIAL_STATE,
  SPECIAL_USER,
  USER_SCOPE_NSWC,
} from '../../utils/constants';
import DetailsPopup from '../CheckerDetails/DetailsPopup/DetailsPopup';
import CheckerFinEditModalPopup from '../CheckerFinEditComponent/CheckerFinEditModalPopup';
import CheckerFinEditDrawer from '../CheckerFinEditDrawer/CheckerFinEditDrawer';
import { getDataFromCheckerDetailsChild, handleCheckerDetailsFilterColumnPayload } from '../Shared/ColumnLevelModal/Utils/ColumnLevelhandleUtils';
import Table from '../Shared/Table/Table';
import { useCheckerColumns } from './CheckerDetailsFilterStructure';
import './CheckerDetailsTable.scss';
import {
  finCellValue,
  getCheckerDetailsFinalFilterColumns, getCheckerDetailsTableStructures,
  pnrCountValue,
  statusPartCheckValue,
} from './CheckerDetailsTableStructure';

interface ReasonDetail {
  FIN?: any;
  MSN?: string;
  ATA?: string;
  Description?: string;
  PopupTableData: Array<any>;
  DeviationDetails: Array<any>;
  finValue?: string;
  operator_code_icao?: string;
  PNR?: any;
}

interface CheckerTableProps {
  exportType: string;
  paramString: any;
}
const CheckerDetailsTable: React.FC<CheckerTableProps> = function LoadingWrapper(props: CheckerTableProps) {
  const { exportType, paramString } = props;
  const [tableData, setTableData] = useState<Array<any>>([]);
  const [reasonDetailsData, setReasonDetailsData] = useState<ReasonDetail>(REASON_DETAIL_INITIAL_STATE);
  const [permissionValue, setPermissionValue] = useState<string>('');
  const {
    isCheckerDetailsDataLoading, paginationData, checkerDetailFiltersSelected, fleet_detail_filter_selected, checkerTableClfState, showFilterPanel, errorMessage, FilterPayload,
  } = useAppSelector(
    (state) => state.displayCheckerDetailsTable,
  );
  const lastMsn = useRef<any>(null);
  const { isDataLoading } = useAppSelector((state) => state.checkerFleet);
  const [selectedFinData, setSelectedFinData] = useState<Array<CheckerSelectedFinDataType>>([]);
  const [checkboxChange, setCheckboxChange] = useState<CheckerSelectedFinDataType>({});
  const [showNoData, setShowNoData] = useState<boolean>(false);
  const [payloadForFilter, setPayloadForFilter] = useState<any>(FilterPayload);
  const checkerDataTableState = useAppSelector((state) => state.displayCheckerDetailsTable);
  const reasonStatusMapping = useAppSelector((state) => state.reasonStatusMapping);
  const { permissionObj, userScope, specialUser } = useAppSelector((state) => state.authEntrySlice);
  const featureToggleConfig = useAppSelector((state) => state.featureToggleDetails?.data);
  const featureToggle = featureToggleConfig?.airnavx_no_fin === 'true';
  const featureToggleFalse = featureToggleConfig?.airnavx_no_fin === 'false';
  const checkerDetailsDispatcher = useAppDispatch();
  const pagination = {
    sourceTab: CHECKER,
    tableState: checkerDataTableState,
    dispatcher: checkerDetailsDispatcher,
    handlePageChange: handleCheckerDetailsPageChange,
    updateTableDataReducer: loadCheckerDetails,
    updatePaginationReducer: updateCheckerDetailsDataPagination,
    featureToggle,
  };
  /* istanbul ignore next */
  const reloadTableData = useCallback(
    (
      selectedTableFilters: Record<string, Array<string>>,
      currentTableFilters: Record<string, Array<string>>,
      sortColumn: string,
      sortOrder: string,
    ) => {
      if (!_.isEqual(currentTableFilters, selectedTableFilters) || !!sortColumn) {
        const conditions = createPayloadObjForChecker(selectedTableFilters, checkerDetailFiltersSelected, fleet_detail_filter_selected, sortColumn, sortOrder, featureToggle);
        const payload = {
          ...conditions,
          offset: Number(DEFAULT_OFFSET),
          limit: Number(getFromLocalStore('apiPaginationSize')),
        };
        setPayloadForFilter(payload);
        if (fleet_detail_filter_selected.selected_msn?.length > 0) {
          checkerDetailsDispatcher(
            loadCheckerDetails(payload)({
              operation: 'columnLevelFilter',
              currentTableFilters,
              selectedTableFilters,
            }),
          );
        }
      }
    },
    [fleet_detail_filter_selected.selected_msn],
  );
  /* istanbul ignore next */
  const loadFilterOptions = useCallback(() => {
    const selectedMsn = fleet_detail_filter_selected.selected_msn ?? [];
    if (
      !_.isEqual(lastMsn.current, selectedMsn)
    ) {
      if (selectedMsn.length === 0) {
        lastMsn.current = selectedMsn;
        return;
      }
      const payload = {
        operator_code_icao: new Array(
          checkerDetailFiltersSelected.operator_name,
        ),
        conditions: {
          id_aircraft_registration: selectedMsn,
        },
        distinct: true,
        columns: [
          'fin_description',
          'status_part_check',
          'acr_pnr',
          'mis_pnr',
          'acr_source_status',
          'mis_source_status',
          'acr_reason',
          'mis_reason',
        ],
        orderBy: ['status_part_check'],
      };
      lastMsn.current = selectedMsn;
      checkerDetailsDispatcher(loadCheckerDetailsClfData(payload)());
    }
  }, [fleet_detail_filter_selected.selected_msn]);

  useEffect(() => {
    checkerDetailsDispatcher(uncheckClfState());
  }, [fleet_detail_filter_selected.selected_msn]);

  useEffect(() => {
    /* istanbul ignore next */
    if (isCheckerDetailsDataLoading === false) {
      // Check if any filter key has a non-empty array value
      // Use checkerTableClfState directly for currentSelectedFilters
      const currentSelectedFilters = extractFilterSelected(checkerTableClfState);
      const hasSelectedFilter = Object.values(currentSelectedFilters).some(
        (val) => Array.isArray(val) && val.length > 0,
      );

      if (errorMessage === 'No data found for the selected filter combination') {
        /* istanbul ignore next */
        checkerDetailsDispatcher(toggleFilterModel(true));
        /* istanbul ignore next */
        setShowNoData(true);
      } else if (hasSelectedFilter) {
        checkerDetailsDispatcher(updateCheckerDetailsColumnFilterPayload({
          ...FilterPayload,
          records: payloadForFilter,
        }));
      }
    } else {
      setShowNoData(false);
    }
  }, [errorMessage, isCheckerDetailsDataLoading]);
  /* istanbul ignore next */
  useEffect(() => {
    if ('eve' in checkboxChange) {
      if (checkboxChange.eve === true) {
        setSelectedFinData(
          [
            ...selectedFinData,
            {
              fleet_fin: checkboxChange.fleet_fin,
              fin_status: checkboxChange.fin_status,
              id_aircraft_registration: checkboxChange.id_aircraft_registration,
              ata: checkboxChange.ata,
              part_number: checkboxChange.part_number,
              pnr_count: checkboxChange.pnr_count,
              user_id: checkboxChange.user_id,
              uniqueid: checkboxChange.uniqueid,
            },
          ],
        );
      } else {
        const newFinArr = [...selectedFinData];
        const selectedIndex = newFinArr.findIndex((value: CheckerSelectedFinDataType) => (value.uniqueid === checkboxChange?.uniqueid));
        newFinArr.splice(selectedIndex, 1);
        setSelectedFinData(newFinArr);
      }
    }
  }, [checkboxChange]);

  useEffect(() => {
    if (selectedFinData !== checkerDataTableState.selectedFin) checkerDetailsDispatcher(setFleetDetailSelectedFin(selectedFinData));
  }, [selectedFinData]);

  useEffect(() => {
    const isOpenDrawer = !!checkerDataTableState.selectedFin.length;
    // Need to set local fin data when directly state changed
    if (checkerDataTableState.selectedFin !== selectedFinData) setSelectedFinData([...checkerDataTableState.selectedFin]);
    // Update select All checkbox based on rows selection
    if ((checkerDataTableState.isSelectAllFin && checkerDataTableState.selectedFin.length !== tableData.length)
      || (tableData.length && !checkerDataTableState.isSelectAllFin && checkerDataTableState.selectedFin.length === tableData.length)) {
      checkerDetailsDispatcher(updateSelectAllBottomDrawerStatus(!checkerDataTableState.isSelectAllFin));
    }
    checkerDetailsDispatcher(setFinBottomDrawerStatus(isOpenDrawer));
    setCheckboxChange({});
  }, [checkerDataTableState.selectedFin]);

  useEffect(() => {
    // While clicking select All, pushing all table rows into selected fin array
    if (checkerDataTableState.isSelectAllFin) {
      const data = paginationData.selectedChunkData.map((item: CheckerTableDataType, index: number) => {
        return {
          fleet_fin: item.fleet_fin,
          fin_status: item.fin_status,
          id_aircraft_registration: item.id_aircraft_registration,
          ata: item.ata,
          part_number: item.pnr,
          pnr_count: item.pnr_count,
          user_id: item.user_id,
          uniqueid: index + item.fleet_fin,
        };
      });
      checkerDetailsDispatcher(setFleetDetailSelectedFin(data));
    }
  }, [checkerDataTableState.isSelectAllFin]);

  // to clear selected checboxes while making changes in top filters or data selection
  useEffect(() => {
    setSelectedFinData([]);
    checkerDetailsDispatcher(updateSelectAllBottomDrawerStatus(false));
  }, [checkerDataTableState.isClearSelection]);

  useEffect(() => {
    const data = paginationData.selectedChunkData.map((item: CheckerTableDataType, index: number) => {
      const dataObj: any = {
        status_checkbox: (
          <Row>
            <Col>
              <Checkbox
                data-testid="select-row-checkbox"
                className="status-editCheckbox"
                checked={checkerDataTableState.selectedFin?.findIndex(
                  (value: CheckerSelectedFinDataType) => (value.uniqueid === (index + item.fleet_fin)),
                ) !== -1}
                onChange={(event) => {
                  setCheckboxChange({
                    fleet_fin: item.fleet_fin,
                    fin_status: item.fin_status,
                    eve: event.target.checked,
                    id_aircraft_registration: item.id_aircraft_registration,
                    ata: item.ata,
                    part_number: item.pnr,
                    pnr_count: item.pnr_count,
                    user_id: item.user_id,
                    uniqueid: index + item.fleet_fin,
                  });
                }}
                onPointerEnterCapture={undefined}
                onPointerLeaveCapture={undefined}
              />
              {item.user_id ? <Chip data-testid="editfin-chip" className="edited-chip" label="Edited" size="xsmall" /> : ''}
            </Col>
          </Row>),
        fin: finCellValue(item.fleet_fin, item.fin_status),
        id_aircraft_registration: item.id_aircraft_registration,
        ata: item.ata,
        description: item.fin_description,
        source: item.source,
        status_part_check: statusPartCheckValue(item.status_part_check),
        pnr: featureToggleConfig?.airnavx_no_fin === 'true' ? pnrCountValue(item.pnr, item.pnr_count) : item.pnr,
        as_allowed_pnr: item.as_allowed_pnr,
        as_allowed_cond: item.as_allowed_cond,
        source_status: item.source_status,
        reason: item.reason,
        details: (
          <div>
            <div className="details-icon">
              <IconButton
                data-testid="reason-details-icon"
                variant="ghost"
                aria-label="circle-outline"
                onClick={() => {
                  setReasonDetailsData({
                    FIN: finCellValue(item.fleet_fin, item.fin_status, item.user_id),
                    MSN: item.id_aircraft_registration,
                    ATA: item.ata,
                    Description: item.fin_description,
                    PopupTableData: item.popup_details,
                    DeviationDetails: item.deviation_details,
                    finValue: item.fleet_fin,
                    operator_code_icao: checkerDetailFiltersSelected.operator_name,
                    PNR: item.pnr,
                  });
                  checkerDetailsDispatcher(setReasonTab({ selectedReasonTab: 0 }));
                  checkerDetailsDispatcher(setCurrentPopupDetails({
                    fin: item.fleet_fin,
                    pnr: item.pnr,
                    msn: item.id_aircraft_registration,
                    ata: item.ata,
                    operator_code_icao: checkerDetailFiltersSelected.operator_name,
                  }));
                  checkerDetailsDispatcher(toggleReasonDetail(true));
                  posthog.capture('MORE_INFO_ICON', {
                    ICON_BUTTON: 'more-info-icon-checked',
                  });
                }}
                placeholder={undefined}
                onPointerEnterCapture={undefined}
                onPointerLeaveCapture={undefined}
              >
                <AddCircleOutline />
              </IconButton>
            </div>
          </div>),
        uniqueid: index + item.fleet_fin,
      };
      // get module name from URL
      const moduleName = window.location.pathname;
      const permissionVal = getPermissionForModule(moduleName, checkerDetailFiltersSelected.operator_name, userScope, permissionObj);
      setPermissionValue(permissionVal);
      /* istanbul ignore next */
      // in case of readonly permission remove edit boxes
      const hasStatusCheckbox = Object.hasOwn(dataObj, 'status_checkbox');
      const isInternalReadOnly = INTERNAL_ABUS.includes(userScope) && READ_ONLY_ARR.includes(permissionVal);
      const isSpecialUser = typeof specialUser === 'string'
        && specialUser.trim().length > 0
        && SPECIAL_USER.toLocaleUpperCase().includes(specialUser.trim().toLocaleUpperCase());

      if (hasStatusCheckbox && (isInternalReadOnly || isSpecialUser)) {
        delete dataObj.status_checkbox;
      }
      return dataObj;
    });

    // layer to process reason details data.
    setTableData(data);
  }, [paginationData.selectedChunkData, checkerDataTableState.selectedFin, permissionObj, userScope]);
  const checkerDetailsFilterColumns = getCheckerDetailsFinalFilterColumns();
  const checkerFilterColumns = useCheckerColumns();
  const filterProps: any = {
    tableState: checkerDataTableState,
    popupFilterState: checkerDataTableState,
    tableStateColumns: checkerDetailsFilterColumns,
    dispatcher: checkerDetailsDispatcher,
    browserThunk: loadCheckerDetails,
    filterThunk: loadCheckerDetailsFilterData,
    filterPayloadFn: handleCheckerDetailsFilterColumnPayload,
    getDataPayloadFn: getDataFromCheckerDetailsChild,
    updateColumnFilterState: updateCheckerDetailsColumnFilterState,
    updateColumnFilterPayload: updateCheckerDetailsColumnFilterPayload,
    reasonStatusMap: reasonStatusMapping,
    filterColumns: checkerFilterColumns,
    validateHandler: reloadTableData,
    loadFilterOptionsHandler: loadFilterOptions,
    currentSelectedFilters: extractFilterSelected(checkerTableClfState),
    uncheckClfState,
    showFilterPanel,
    showNoData,
  };
  return (
    <div>
      {paginationData.selectedChunkData.length > 0 ? (
        <Container className="checker-details-container">
          {featureToggleFalse && featureToggleConfig?.nswc === 'true' && userScope === USER_SCOPE_NSWC
            && (
              <Typography className="data-warning-text" variant="small" data-testid="checker-warning-data">
                {DATA_WARNING_TEXT}
              </Typography>
            )}
          <Table
            data-testid="checker-data-table"
            tableData={tableData}
            headerColumns={getCheckerDetailsTableStructures(permissionValue, userScope, specialUser)}
            loadingupdate={isCheckerDetailsDataLoading}
            showChangeViewButton={false}
            showExportButton={featureToggleConfig?.exportChecker === 'true'}
            showFilterButton
            filterProps={filterProps}
            tableClassName={checkerDataTableState.selectedFin.length ? 'checker-data-table-fin-edit' : 'checker-data-table'}
            showTimeInfo
            showPagination
            paginationProps={pagination}
            selectedExport={checkerDataTableState.checkerDetailFiltersSelected}
            exportType={exportType}
            disableToolbarComponent={checkerDataTableState.selectedFin.length > 0}
            showReportToggleStatus
            paramString={paramString}
            selectedModule="CHECKER"
          />
          <DetailsPopup
            popupData={reasonDetailsData}
          />
          <CheckerFinEditDrawer />
          <CheckerFinEditModalPopup />
        </Container>
      ) : (
        <Container className="checker-no-data">
          {paginationData.selectedChunkData.length === 0 && isCheckerDetailsDataLoading === false && isDataLoading === false ? (
            <Typography className="no-data-text" data-testid="no-checker-data">
              {NO_TABLE_RECORDS_FOUND}
            </Typography>
          ) : (
            <Spinner size="small" className="checker-spinner" />
          )}
        </Container>
      )}
    </div>
  );
};
export default CheckerDetailsTable;
